import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { useThemeContext } from '../../../../hook/useThemeManager';
import { theme } from '../../../../constants/theme';
import { FONT_ENUM } from '../../../../types/global/fonts.types';
import { BarChart } from '@mui/icons-material';

export const EventAnalyticsTab: React.FC = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: '1.25rem',
                    color: theme[themeStyle].primary_white,
                    mb: 3,
                }}>
                Event Analytics
            </Typography>

            <Card
                sx={{
                    backgroundColor: theme[themeStyle].table_header,
                    borderRadius: 2,
                    textAlign: 'center',
                    py: 6,
                }}>
                <CardContent>
                    <BarChart sx={{ fontSize: 64, color: theme[themeStyle].primary_white, mb: 2 }} />
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            fontSize: '1.5rem',
                            color: theme[themeStyle].primary_white,
                            mb: 1,
                        }}>
                        Event Analytics Coming Soon
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            fontSize: '1rem',
                            color: theme[themeStyle].light_gray_text,
                            maxWidth: 500,
                            mx: 'auto',
                        }}>
                        We're working on advanced analytics for your events. Soon you'll be able to track ticket sales,
                        attendance rates, revenue metrics, and more in this section.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};
